import { useTranslation } from 'react-i18next';

import { useAuthUser } from 'auth/hooks';
import { Error, PageLayout, PageTitle } from 'core/components';
import { StatusCode } from 'core/constants';
import { SubmitOrderLog } from 'dashboard/components';

export const SubmitOrderLogPage = () => {
  const { t } = useTranslation();

  const { user, isFetched } = useAuthUser();

  const title = t('titleSubmitOrderLog');

  if (isFetched && !user?.admin) {
    return <Error statusCode={StatusCode.ACCESS_DENIED} />;
  }

  return (
    <PageLayout scrollable title={title}>
      <PageTitle title={title} />
      <SubmitOrderLog />
    </PageLayout>
  );
};
